import { useState } from "react";

function getInitials(name) {
  const first = name.split(" ").find(w => /^[a-zA-Z]/.test(w));
  return first ? first[0].toUpperCase() : (name[0] || "?").toUpperCase();
}


function BusinessList({ businesses, onSelect, onDelete, onClearAll, selected, alertMap }) {
  const [isOpen, setIsOpen] = useState(true);

  if (!businesses || businesses.length === 0) return null;

  const visible = businesses.slice(0, 5);

  return (
    <div className="sb-panel">
      <div className="sb-toggle-row">
        <button className="sb-toggle" onClick={() => setIsOpen((o) => !o)}>
          <span className="sb-label">Recent Searches</span>
          <span className={`sb-chevron ${isOpen ? "open" : ""}`}>›</span>
        </button>
        {isOpen && (
          <button className="sb-clear-all" onClick={onClearAll} title="Clear all searches">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
              <path d="M10 11v6M14 11v6" />
              <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
            </svg>
          </button>
        )}
      </div>

      {isOpen && (
        <ul className="sb-list">
          {visible.map((biz) => {
            const isActive = selected === biz;
            const hasAlert = alertMap?.[biz];
            return (
              <li
                key={biz}
                className={`sb-item ${isActive ? "active" : ""}`}
                onClick={() => onSelect(biz)}
                title={biz}
              >
                <div className="sb-avatar-wrap">
                  <div className="sb-avatar">{getInitials(biz)}</div>
                  {hasAlert && <span className="sb-alert-dot" title="High negative review rate" />}
                </div>
                <span className="sb-name">{biz}</span>
                <button
                  className="sb-del"
                  onClick={(e) => { e.stopPropagation(); onDelete(biz); }}
                  title="Remove"
                >
                  ✕
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

export default BusinessList;
